if (typeof ShippingNotice !== 'function') {

	class ShippingNotice extends HTMLElement {

		constructor() {
			super();
			this.init();
		}

		init() {

			// Inputs (in cents)
			const thresholdCentsRaw = Number(this.getAttribute('data-free-shipping')) || 0;
			const cartTotalCents = Number(this.getAttribute('data-cart-total-amount')) || 0;

			// Currency conversion
			const rate = (window.Shopify && Shopify.currency && Shopify.currency.rate)
				? Number(Shopify.currency.rate)
				: 1;

			const thresholdCents = Math.max(0, Math.round(thresholdCentsRaw * rate));

			const eligible = thresholdCents === 0 ? true : cartTotalCents >= thresholdCents;
			const remainingCents = eligible ? 0 : Math.max(thresholdCents - cartTotalCents, 0);

			// New percent
			const nextPercent = thresholdCents === 0
				? 100
				: Math.min(100, Math.max(0, (cartTotalCents / thresholdCents) * 100));

			// Global previous percent (persist across section swaps)
			if (typeof window.__shippingProgress !== 'number') {
				window.__shippingProgress = nextPercent; // first load baseline (change to nextPercent if you prefer no initial sweep)
			}
			const prevPercent = window.__shippingProgress;

			// Messages
			const fmt = (c) => this._formatMoney(c, window.KROWN?.settings?.shop_money_format);
			const remainingTpl =
				window.KROWN?.settings?.locales?.shipping_notice_remaining_to_free ||
				'Spend {{ remaining_amount }} more to get free shipping';
			const eligibleTpl =
				window.KROWN?.settings?.locales?.shipping_notice_eligible_for_free ||
				'Congrats! You get free shipping ✧';
			const message = eligible
				? eligibleTpl
				: remainingTpl.replace('{{ remaining_amount }}', fmt(remainingCents));

			this.innerHTML = `
				<div class="shipping-threshold ${eligible ? 'is-fulfilled' : ''}" role="status" aria-live="polite">
					<div class="shipping-threshold__message">${message}</div>
					<div
						class="shipping-threshold__progress"
						role="progressbar"
						aria-valuemin="0"
						aria-valuemax="${thresholdCents}"
						aria-valuenow="${Math.min(cartTotalCents, thresholdCents)}"
					>
						<span class="shipping-threshold__bar"></span>
					</div>
					<div class="shipping-threshold__meta" aria-hidden="true">
						<span class="shipping-threshold__current">${fmt(cartTotalCents)}</span>
						<span class="shipping-threshold__sep">/</span>
						<span class="shipping-threshold__target">${fmt(thresholdCents)}</span>
					</div>
				</div>
			`;

			const bar = this.querySelector('.shipping-threshold__bar');
			if (!bar) return;

			const prefersNoMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			if (prefersNoMotion) {
				bar.style.transition = 'none';
			}

			// 1) set to previous width (no animation)
			bar.style.width = `${prevPercent}%`;
			// 2) force reflow to commit prev width
			void bar.offsetWidth;
			// 3) animate to next percent (CSS handles .3s easing)
			requestAnimationFrame(() => {
				bar.style.width = `${nextPercent}%`;
			});

			// 4) after animation, update global to the latest percent
			const done = () => {
				window.__shippingProgress = nextPercent;
				bar.removeEventListener('transitionend', done);
			};
			bar.addEventListener('transitionend', done);
		}


		_formatMoney(cents, format) {
			if (typeof cents === 'string') cents = cents.replace('.', '');
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || '{{ amount }}';

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
				if (isNaN(number) || number === null) return 0;
				number = (number / 100.0).toFixed(precision);
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
				return dollarsAmount + centsAmount;
			}

			switch ((formatString.match(placeholderRegex) || [, 'amount'])[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);
		}
	}

	if (typeof customElements.get('shipping-notice') === 'undefined') {
		customElements.define('shipping-notice', ShippingNotice);
	}
}
